import React from "react";
import LayoutCenter from "../UserInterface/LayoutCenter";

type BlogWysiwygProps = {
  innerHtml: any;
  marginMobile?: string;
};

const BlogWysiwyg = ({ innerHtml, marginMobile }: BlogWysiwygProps) => {
  return (
    <LayoutCenter alignMobile="flex-start" width="100%">
      <div
        className="wysiwyg"
        dangerouslySetInnerHTML={{ __html: innerHtml }}
      />
      <style jsx>{`
        .wysiwyg {
          margin: 0px;
        }

        @media only screen and (max-width: 850px) {
          .wysiwyg {
            margin: ${marginMobile ? marginMobile : "0 24px"};
            margin-top: 30px;
            font-size: 17px;
          }
        }
      `}</style>
      <style jsx global>{`
        strong {
          font-weight: bold;
        }
        .wysiwyg p {
          text-align: left;
        }
        .wysiwyg figure img {
          max-width: 100%;
        }

        .wysiwyg table {
          border-collapse: collapse;
        }

        .wysiwyg table,
        th,
        td {
          border: 1px solid black;
          padding: 8px;
        }
        .wysiwyg ul {
          list-style-type: disc;
          text-align: left;
        }
        .wysiwyg ol {
          text-align: left;
        }
        .wysiwyg li {
          margin-left: 40px;
          text-align: left;
        }
        .wysiwyg a {
          color: var(--color-red);
        }
        @media only screen and (max-width: 850px) {
          .wysiwyg figure img {
            width: 90vw;
          }
          .wysiwyg table {
            font-size: 10.5px;
          }
          .wysiwyg table,
          th,
          td {
            padding: 2px;
          }
        }
      `}</style>
    </LayoutCenter>
  );
};

export { BlogWysiwyg };
